module.exports = "/assets/data/86de8e318ea6e0979bc98fbf11c4e3a0-DY2.data.json";